"use strict";
exports.__esModule = true;
exports.permissionsSchema = void 0;
var validate_1 = require("./utils/validate");
var roleSchema = validate_1.oneOf(['anyone', 'siteMember', 'siteMemberAuthor', 'admin']);
exports.permissionsSchema = {
    insert: roleSchema,
    read: roleSchema,
    update: roleSchema,
    remove: roleSchema
};
//# sourceMappingURL=permissionsSchema.js.map